import { useUniqueId } from '@coreui/vue-pro'
import { defineStore } from 'pinia'
import type { IErrorResponse } from '~/plugins/errorCodeHandler'

export const TOAST_DELAY = 5000

export enum EToastType {
  SUCCESS = 1,
  DANGER,
  WARNING,
}

export interface IToastProps {
  content?: string
  type?: EToastType
  title?: string
  error?: IErrorResponse | any
}

export interface IToast extends IToastProps {
  id: string
}

export const useToastStore = defineStore('toast', () => {
  const toasts = reactive<IToast[]>([])
  const { $errorCodeHandler } = useNuxtApp()

  const createToast = (toastProps: IToastProps) => {
    // Erro 401 não vai exibir toast
    if (
      toastProps.error &&
      toastProps.error.response &&
      toastProps.error.response.status === 401
    )
      return

    const id = useUniqueId().getUID()
    if (toastProps.error) {
      toastProps.content = $errorCodeHandler(toastProps.error)
      toastProps.type = EToastType.DANGER
    }

    toasts.push({ id, ...toastProps })
  }

  const removeToast = (toastId: string) => {
    const index = toasts.findIndex((toast) => toast.id === toastId)
    if (index >= 0 && index < toasts.length) {
      toasts.splice(index, 1)
    }
  }

  const hasToast = computed(() => toasts.length > 0)

  return { toasts, createToast, removeToast, hasToast }
})
